import * as React from 'react';

import headerLogo from '../assets/images/flax-logo.svg';


export const HeaderLogo = (props: React.HTMLAttributes<HTMLImageElement>) => (
  <a href="/"><img src={headerLogo} alt="Header Logo" width="240px"
    className="uk-margin-left uk-margin-botton" /></a>
);

